import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import ThemeProvider from "@/context/ThemeProvider";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import Product from "@/pages/Product";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import Institutional from "@/pages/Institutional";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminMaterials from "@/pages/admin/AdminMaterials";
import AdminSizes from "@/pages/admin/AdminSizes";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminContent from "@/pages/admin/AdminContent";

const Wrapped = ({ children }) => <Layout>{children}</Layout>;

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <CartProvider>
          <Toaster position="top-right" richColors toastOptions={{ style: { fontFamily: "Montserrat, sans-serif" } }} />
          <Routes>
            <Route path="/" element={<Wrapped><Home /></Wrapped>} />
            <Route path="/catalogo" element={<Wrapped><Catalog /></Wrapped>} />
            <Route path="/produto/:slug" element={<Wrapped><Product /></Wrapped>} />
            <Route path="/carrinho" element={<Wrapped><Cart /></Wrapped>} />
            <Route path="/checkout" element={<Wrapped><Checkout /></Wrapped>} />
            <Route path="/pedido-confirmado/:id" element={<Wrapped><OrderSuccess /></Wrapped>} />
            <Route path="/login" element={<Wrapped><Login /></Wrapped>} />
            <Route path="/cadastro" element={<Wrapped><Register /></Wrapped>} />
            <Route path="/conta" element={<Wrapped><Account /></Wrapped>} />
            <Route path="/institucional" element={<Wrapped><Institutional /></Wrapped>} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="produtos" element={<AdminProducts />} />
              <Route path="categorias" element={<AdminCategories />} />
              <Route path="materiais" element={<AdminMaterials />} />
              <Route path="tamanhos" element={<AdminSizes />} />
              <Route path="pedidos" element={<AdminOrders />} />
              <Route path="clientes" element={<AdminCustomers />} />
              <Route path="conteudo" element={<AdminContent />} />
            </Route>
          </Routes>
        </CartProvider>
      </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
